import { PropertyManagementCompanyName } from './components/PropertyManagementCompanyName';
import { PropertyManagementCompanyWebsite } from './components/PropertyManagementCompanyWebsite';
import { ManagementAgreementFile } from '../../../../../components/FileOrFormQuestions/questions/ManagementAgreementFile';
import { Attachment } from '../../../../../components/FileOrFormQuestions/types/Attachment';

interface PropertyManagementCompanyProps {
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    onFileChanged?: (guid: string, value: number | string | boolean | Date | Attachment) => void;
}

export const PropertyManagementCompany: React.FC<PropertyManagementCompanyProps> = ({
    required = false,
    readOnly = false,
    isReview = false,
}) => {
    return (
        <>
            {isReview ? (
                <>
                    <br />
                    <span style={{ fontWeight: 600 }}>Property Management Company:</span>
                    <br />
                    <br />
                    <PropertyManagementCompanyName
                        required={required}
                        isReview={isReview}
                        readOnly={readOnly}
                    />
                    <PropertyManagementCompanyWebsite
                        required={required}
                        isReview={isReview}
                        readOnly={readOnly}
                    />
                    <ManagementAgreementFile
                        required={required}
                        isReview={isReview}
                    />
                </>
            ) : (
                <div style={{ marginTop: '30px' }}>
                    <div className='pageSubHeader'>Property Management Company</div>
                    <PropertyManagementCompanyName
                        required={required}
                        isReview={isReview}
                        readOnly={readOnly}
                    />
                    <PropertyManagementCompanyWebsite
                        required={required}
                        isReview={isReview}
                        readOnly={readOnly}
                    />
                    <ManagementAgreementFile
                        required={true}
                        isReview={isReview}
                    />
                </div>
            )}
        </>
    );
};
